import * as types from '../actions/actionTypes'
import { AccountData } from '@brainstud/react-tbl/themes/pgw/v1/config'

// ToDo: Allow all chapters to be followed in a-linear order
const initialState = {
  isLoggedIn: false,
  isLoading: false,
  isOffline: false,
  error: null,
  ...AccountData,
}

export default function accountReducer(state = initialState, action) {
  switch(action.type) {
    case types.LOGIN_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        isLoggedIn: false,
        error: null
      })

    case types.LOGIN_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        isLoggedIn: false,
        error: action.payload
      })

    case types.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isLoggedIn: true,
        user: {...action.payload.user},
        progress: [...action.payload.progress],
        lastProgress: [...action.payload.lastProgress],
        endtest: {...action.payload.endtest},
        chapters: [...action.payload.chapters],
      })

    case types.UPDATE_PROGRESS_SUCCESS:
      return Object.assign({}, state, {
        progress: state.progress.map(item => item.id === action.payload.id
          ? {...item, ...action.payload}
          : item)
      })

    case types.UPDATE_LAST_PROGRESS_SUCCESS:
      return Object.assign({}, state, {
        lastProgress: [...state.progress]
      })

    case types.UPDATE_ENDTEST_SUCCESS:
      return Object.assign({}, state, {
        endtest: {...action.payload}
      })

    case types.UPDATE_CHAPTERS_SUCCESS:
      const exists = state.chapters.find(item => item.cId === action.payload.cId && item.aId === action.payload.aId)

      return Object.assign({}, state, {
        chapters: exists
          ? state.chapters.map(item => item.cId === action.payload.cId && item.aId === action.payload.aId
            ? {...item, ...action.payload}
            : item)
          : state.chapters.concat({...action.payload})
      })

    case types.UPDATE_ACCOUNT_API_SUCCESS:
      return Object.assign({}, state, {
        isOffline: false
      })

    case types.UPDATE_ACCOUNT_API_ERROR:
      return Object.assign({}, state, {
        isOffline: true
      })

    case types.LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: false
      })

    default:
      return state
  }
}